import { useSearchParams } from 'react-router-dom';

import { CATEGORY_URL_PARAM } from 'hb-react/frontoffice/apps/Forum/constants';
import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import { useGetCategories } from 'hb-react/frontoffice/apps/Forum/hooks/queries/useGetCategories';
import { SelectArray } from 'hb-react/shared/components/formik/components/inputs';

const SelectCategories = () => {
  const { appPageConfig, configUrls } = useForumContext();
  const [, setSearchParams] = useSearchParams();
  const { categories, isLoading } = useGetCategories(configUrls);
  const options = categories.map(({ name, id }) => ({
    value: id,
    label: name,
  }));

  const isCategoryFieldMandatory =
    appPageConfig?.config?.set_category_field_mandatory;

  return (
    <SelectArray
      name="category_ids"
      id="category_ids"
      options={options}
      isLoading={isLoading}
      multiple
      label={s__('Forum|Choose categorie(s)')}
      placeholder={s__('Forum|Select a category')}
      onChange={(values: { value: number; label: string }[]) => {
        setSearchParams(
          {
            [CATEGORY_URL_PARAM]: values.map((elem) => `${elem.value}`),
          },
          { replace: true },
        );
      }}
      validate={{
        required: isCategoryFieldMandatory,
      }}
    />
  );
};

export default SelectCategories;
